export const DIM_OPACITY = 0.1
